import { formatDate } from '../../../../common-utilities/utils';
import { DATE_FORMATS } from '../../../../common-utilities/utils/constants';

export const getHeaderConfig = () => {
  return [
    {
      label: 'Old Price',
      id: 'oldPrice',
    },
    {
      label: 'New Price',
      id: 'newPrice',
    },
    {
      label: 'Old Tax Percentage',
      id: 'oldTaxPercentage',
    },
    {
      label: 'New Tax Percentage',
      id: 'newTaxPercentage',
    },
    {
      label: 'Old Valid From',
      id: 'oldFromDate',
      render: (data) => formatDate(data.oldFromDate, DATE_FORMATS['DD-MM-YYYY']),
    },
    {
      label: 'New Valid From',
      id: 'newFromDate',
      render: (data) => formatDate(data.newFromDate, DATE_FORMATS['DD-MM-YYYY']),
    },
    {
      label: 'Old Valid To',
      id: 'oldToDate',
      render: (data) => formatDate(data.oldToDate, DATE_FORMATS['DD-MM-YYYY']),
    },
    {
      label: 'New Valid To',
      id: 'newToDate',
      render: (data) => formatDate(data.newToDate, DATE_FORMATS['DD-MM-YYYY']),
    },
    {
      label: 'Changed By',
      id: 'changedByName',
    },
    {
      label: 'Changed At',
      id: 'createdAt',
      render: (data) => formatDate(data.createdAt, DATE_FORMATS['DD-MM-YYYY']),
    },
  ];
};
